import React from "react"
import { graphql, Link } from "gatsby"
//import { StaticImage } from 'gatsby-plugin-image'
//import { AnchorLink } from "gatsby-plugin-anchor-links";
import * as styles from "../styles/page/top.module.scss"

// 共通コンポーネント
import Layout from "../components/layouts/default"
import Meta from "../components/layouts/meta"

// 記事データ
import TopProject from "../components/parts/top/project" // プロジェクト

// markup
const IndexPage = ({ data }) => {
  const projectData = data.project.edges

  const title = 'Top'
  const description = 'In October 2020, Japan declared that it aims to achieve carbon neutrality by 2050, with the goal of reducing overall greenhouse gas emissions to zero by 2050. Carbon neutrality by 2050 cannot be realized through ordinary efforts. It is necessary to significantly accelerate efforts toward structural changes in the energy and industrial sectors, and undertake bold investment for innovation.'

  return (
    <Layout>
      <Meta 
        title={title}
        description={description}
      />
      <div className={styles.mainVisual}>
        <div className={styles.mainVisualInner}>
          <div className={styles.mainVisualText}>
            <h1 className={styles.mainVisualTextEyeCatch}>Working toward a carbon-neutral future.</h1>
            <p className={styles.mainVisualTextLead}>The driving force behind Japan's future growth is the <br />challenge of achieving carbon neutrality.</p>
            <p className={styles.mainVisualTextLead}>Now is the time for Japan-A technological superpower <br />One world-changing innovation after another.</p>
            <p className={styles.mainVisualTextLead}>Working together to create a carbon-neutral future. <br />A new Japan is waiting in 2050.</p>
          </div>
        </div>
      </div>

      <main className={styles.topContents}>
      
        {/*<div className={styles.contentsBanner}>
          <div className={styles.contentsBannerWrap}>
            <a href="https://youtu.be/3waZmmkA5gg" target="_blank" rel="noopener noreferrer" className={`${styles.contentsBannerCard} ${styles.interviewVol2}`}>
              <div className={styles.contentsBannerCardMoveiButton}>
                <img src="/images/top/movie-button.png" alt="" />
              </div>
              <h2 className={styles.contentsBannerCardSmallTitle}>
                Management Interview Video vol.2 〜Carbon Recycling〜
              </h2>
            </a>
            <a href="https://youtu.be/XcTf946BE5U" target="_blank" rel="noopener noreferrer" className={`${styles.contentsBannerCard} ${styles.interviewVol1}`}>
              <div className={styles.contentsBannerCardMoveiButton}>
                <img src="/images/top/movie-button.png" alt="" />
              </div>
              <h2 className={styles.contentsBannerCardSmallTitle}>
                Management Interview Video vol.1 〜Hydrogen Supply Chain〜
              </h2>
            </a>
          </div>
        </div>*/}

        <div className={styles.movie}>
          <div className={styles.contentsBanner}>
            <div className={styles.contentsBannerWrapList}>
              <div className={styles.contentsBannerCardWrap}>
                <a href="https://www.youtube.com/watch?v=SzJQUSvbo2E&list=PLZH3AKTCrVsWw4KkmV-HTwydeXatna6N8" target="_blank" rel="noopener noreferrer" className={styles.contentsBannerCard}>
                  <img src="/en/images/top/interview-banner-vol3.png" alt="" />
                  <div className={styles.contentsBannerCardMoveiButton}>
                    <img src="/en/images/top/movie-button.png" alt="" />
                  </div>
                  <h2 className={styles.contentsBannerCardSmallTitle}>
                    Interview Video  ～Biomanufacturing～
                  </h2>
                </a>
                <p className={styles.allLists}><Link className={styles.allListsBullet} to="/movie/">View all Movies</Link></p>
              </div>
              <a href="https://www.nedo.go.jp/content/100957298.pdf" target="_blank" rel="noopener noreferrer" className={styles.contentsBannerCard}>
                <img src="/en/images/top/pic-relatedInformation.png" alt="" />
                <div className={styles.contentsBannerCardSmallTitle}>&nbsp;</div>
                <span className={styles.contentsBannerCardBullet}>Brochure</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className={styles.contentsBanner}>
          <div className={styles.contentsBannerWrap}>
            <Link to="/dashboard/" className={`${styles.contentsBannerCard} ${styles.wide}`}>
              <img src="/en/images/top/pic-publicOffering.png" alt="" className="spNone" />
              <img src="/en/images/top/pic-projectDashboard.png" alt="" className="pcNone" />
              <h2 className={styles.contentsBannerCardTitle}>
                DASHBOARD
                <span className={styles.contentsBannerCardSub}>Dashboard</span>
              </h2>
              <div className={styles.contentsBannerCardSmallTitle}>&nbsp;</div>
              <span className={styles.contentsBannerCardBullet}>For further information</span>
            </Link>
          </div>
        </div>

        <div className={styles.project}>
          <h2 className={styles.headingTop}>Projects</h2>
          <div className={styles.projectInner}>
            {projectData.map( (item, id) => {
              return <TopProject key={`top-project-${id}`} index={id} data={item.node} />
            })}
          </div>
          <p className={styles.allLists}><Link className={styles.allListsBullet} to="/project/">View all Projects</Link></p>
        </div>
                
      </main>
    </Layout>
  )  
}
export default IndexPage

export const query = graphql`
  query TopPageQuery {
    project: allProjectsJson {
      edges {
        node {
          slug
          title
          description
          mainImage
        }
      }
    }
  }
`